import { Injectable } from '@angular/core';

import { IAsyncTaskReport, ITask } from './async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class BinderGenerateInvoiceAttachmentsReport implements IAsyncTaskReport {

  public generate(task: ITask): string {
    const detail = task.detail || {};
    const binderId = detail.binder_id;
    const binderCode = detail.binder_code;

    if (task.status === 'success' || task.status === 'warning') {
      const generated = detail.num_generated ?? 0;
      const total = detail.num_demat_invoices ?? generated;
      const errors = detail.num_errors ?? 0;

      let htmlDetail = `<div>Generation des pieces jointes PDF/XLSX terminee: ${generated}/${total} facture(s) traitee(s).</div>`;

      if (errors > 0) {
        htmlDetail += `<div>${errors} facture(s) n'ont pas pu etre traitee(s).</div>`;
      }

      if (binderId && binderCode) {
        htmlDetail += `<div>Binder associe : <a href="#/binders/detail/${binderId}">${binderCode}</a>.</div>`;
      }

      return htmlDetail;
    }

    return '<div>Erreur lors de la generation des pieces jointes PDF/XLSX du binder.</div>';
  }
}

